var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBanner({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 400,
    viewBox: "0 0 1920 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_99)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1920 0H0V399.8H1920V0Z",
    fill: "#F02323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1520 0H1120V200H1520V0Z",
    fill: "#FCA430"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1520.13 199.555H1120.13V399.77H1520.13V199.555Z",
    fill: "#4C519A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1420 199.226H1220.25V399.78H1420V199.226Z",
    fill: "#FCA430"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1520 199.965H1120C1130.57 -65.1464 1509.54 -64.9266 1520 199.965Z",
    fill: "#4C519A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1220.25 201.074C1225.54 68.5132 1415.02 68.6331 1420.25 201.074Z",
    fill: "#FCA430"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1720 399.77H1520V295.802C1519.75 239.596 1568.39 196.049 1624.07 199.965C1677.05 199.965 1720 242.873 1720 295.802V399.77Z",
    fill: "#FCA430"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1920 399.77H1720V198.966L1920 399.77Z",
    fill: "#FCA430"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1889.66 367.472L1750.28 228.227C1788.77 189.775 1851.17 189.775 1889.66 228.227C1928.15 266.68 1928.15 329.019 1889.66 367.472Z",
    fill: "#FB501A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1784.64 264.552C1804.17 245.041 1835.82 245.041 1855.35 264.552C1874.88 284.063 1874.88 315.682 1855.35 335.193",
    fill: "#FCA430"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1785.09 264.113C1765.56 283.624 1765.56 315.243 1785.09 334.754C1804.62 354.265 1836.27 354.265 1855.8 334.754",
    fill: "#4C519A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.09 399.805H807.5L806.09 200L1006.09 399.805Z",
    fill: "#4C519A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1072.48 368.74L926.26 232.423C963.94 192.083 1027.22 189.895 1067.6 227.538C1107.98 265.181 1110.17 328.4 1072.49 368.74H1072.48Z",
    fill: "#FB501A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M962.81 266.51C981.65 246.34 1013.29 245.251 1033.48 264.072C1053.67 282.894 1054.76 314.503 1035.92 334.674",
    fill: "#FCA430"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M963.27 266.08C944.43 286.25 945.52 317.859 965.71 336.681C985.9 355.502 1017.54 354.413 1036.38 334.243",
    fill: "#4C519A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1720 199.965L1520 0H1720V199.965Z",
    fill: "#4C519A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.07 201.074V0.160034L306.11 100.622L204.07 201.074Z",
    fill: "#4C519A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.27 199.835L306.11 100.5V199.835H203.27Z",
    fill: "#4C519A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408 0L407.41 200.343L306 100.5L408 0Z",
    fill: "#4C519A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M891.9 198.736L891 0L1004.95 100.082L891.9 198.736Z",
    fill: "#4C519A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1920 199.965L1720 0H1920V199.965Z",
    fill: "#FCA430"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M890.91 199.965L683.39 0.259766H890.91V199.965Z",
    fill: "#FB501A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.07 201.074L0 0.160034H204.07V201.074Z",
    fill: "#FB501A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M890.91 97.1553L794 0H891L890.91 97.1553Z",
    fill: "#FCA430"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.53 400L0 289.578V400H110.53Z",
    fill: "#FCA430"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1849.29 175.049L1749.29 75.1467V175.049H1849.29Z",
    fill: "#4C519A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1620 199.965L1520 100.062V199.965H1620Z",
    fill: "#FB501A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.07 399.7V199.835H408.14L204.07 399.7Z",
    fill: "#FCA430"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.07 198.836V298.479H301.77L204.07 198.836Z",
    fill: "#4C519A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.07 198.836V298.479H106.37L204.07 198.836Z",
    fill: "#FCA430"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.07 398.112V298.479H106.37L204.07 398.112Z",
    fill: "#4C519A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1620 265.112C1593.51 265.112 1572.03 286.571 1572.03 313.035H1667.96C1667.96 286.571 1646.48 265.112 1619.99 265.112H1620Z",
    fill: "#4C519A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1620 360.948C1593.51 360.948 1572.03 339.489 1572.03 313.025H1667.96C1667.96 339.489 1646.48 360.948 1619.99 360.948H1620Z",
    fill: "#FB501A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.14 399.77H408.14V295.802C407.89 239.596 456.53 196.049 512.21 199.965C565.19 199.965 608.14 242.873 608.14 295.802V399.77Z",
    fill: "#FCA430"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.14 264.113C481.65 264.113 460.17 285.572 460.17 312.036H556.1C556.1 285.572 534.62 264.113 508.13 264.113H508.14Z",
    fill: "#4C519A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.14 359.949C481.65 359.949 460.17 338.49 460.17 312.026H556.1C556.1 338.49 534.62 359.949 508.13 359.949H508.14Z",
    fill: "#4C519A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.17 361.727C305.8 352.366 305.8 337.201 315.17 327.84L349.09 361.727C339.72 371.088 324.54 371.088 315.17 361.727Z",
    fill: "#4C519A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.08 327.85C339.71 318.489 324.53 318.489 315.16 327.85L349.08 361.737C358.45 352.376 358.45 337.211 349.08 327.85Z",
    fill: "#FCA430"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.53 365.244C652.16 355.883 652.16 340.718 661.53 331.357L695.45 365.244C686.08 374.605 670.9 374.605 661.53 365.244Z",
    fill: "#4C519A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.45 331.357C686.08 321.996 670.9 321.996 661.53 331.357L695.45 365.244C704.82 355.883 704.82 340.718 695.45 331.357Z",
    fill: "#FB501A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.5 399.5L607 200H807L807.5 399.5Z",
    fill: "#4C519A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408 0H606.5L607 201L408 0Z",
    fill: "#FCA430"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606 0L806.77 201.074H606.77L606 0Z",
    fill: "#FCA430"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1119.98 199.615V0L1006 100.082L1119.98 199.615Z",
    fill: "#4C519A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408 0L306.11 100.462V0H408Z",
    fill: "#4C519A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_99"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 400,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanner);
export default __webpack_public_path__ + "static/media/banner.de098f317e93a6fa22815a4dc20b7274.svg";
export { ForwardRef as ReactComponent };